
import React from 'react'
import { Box, VBox } from './Box'
import Popover from './Popover'
import Menu from './Menu'
import Text from './Text'
import Avatar from './Avatar'
import { LogOut } from 'react-feather'
import './TeamSelect.css'

/**
 * TeamSelect component.
 */

export default function TeamSelect({ user, team, teams, onChange }) {
  function content({ close }) {
    function select(team) {
      close()
      onChange(team)
    }

    return <Box>
      {/* <VBox alignX="center" paddingY={8} lineHeight={1.5} borderBottom>
        <Avatar name={user.name || user.email} marginBottom={3} />
        {user.name && <Text userSelect="none">{user.name}</Text>}
        <Text userSelect="none" muted>{user.email}</Text>
      </VBox> */}

      <Menu full>
        {teams.sort(byName).map(t => {
          return <Menu.Item
            key={t.name}
            selected={t.name == team.name}
            onSelect={_ => select(t)}
          >
            {t.name}
          </Menu.Item>
        })}
      </Menu>

      <UserMenu />
    </Box>
  }

  return <Popover content={content} position="bottom left" offsetX={8}>
    <Box className="TeamSelect">
      {team.name}
    </Box>
  </Popover>
}

/**
 * UserMenu component.
 */

function UserMenu() {
  return <VBox borderTop>
    <Menu full>
      <Menu.Item to="/logout" icon={LogOut}>Sign out</Menu.Item>
    </Menu>
  </VBox>
}

/**
 * byName sort.
 */

function byName(a, b) {
  return a.name.localeCompare(b.name)
}